export const GET_SINGLE_ORGANIZATION_OVERVIEW_START =
  'GET_SINGLE_ORGANIZATION_OVERVIEW_START';
export const GET_SINGLE_ORGANIZATION_OVERVIEW_SUCCESS =
  'GET_SINGLE_ORGANIZATION_OVERVIEW_SUCCESS';
export const GET_SINGLE_ORGANIZATION_OVERVIEW_ERROR =
  'GET_SINGLE_ORGANIZATION_OVERVIEW_ERROR';
